export default __webpack_public_path__ + "static/media/howweusedc.7b61f901.png";